export const defaultStyle = {
  wrapper:
    "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto md:mb-[25px] px-[30px] lg:px-[15px] lg:[&>div>div>div]:text-left md:[&>div>div>div]:text-center [&>div>div>div]:text-center max-md:py-10",
  title:
    "text-[24px] lg:text-[48px] text-green font-Light my-[45px] leading-[1.2] tracking-normal font-light mt-0 w-full md:text-[24px] pl-[15px] ",
  linkClass:
    "linkclass font-Regular font-bold text-[14px] mb-0 text-left md:text-[21px] text-purple tracking-[2.2px] hover:text-orange hover:underline uppercase inline-flex justify-center items-center ",
}
export const LOWER_SENTENCECASE_LINK_CONTENT = {
  ...defaultStyle,
  linkClass: "font-Regular font-bold text-[14px] mb-0 text-left md:text-[21px] text-purple tracking-[2.2px] hover:text-orange hover:underline inline-flex justify-center items-center ",
}
export const SECTION_9_3_PART_TABCONTAINER = {
  //NOTE :SPECIALLY this variant is used for /makers-bakers-bulletin-board page
  bgWrapper:
    "tabContainerRightSection w-full lg:w-1/4 py-50 mx-15 md:mx-30 lg:ml-0 lg:mr-0 px-15",
  wrapper:
    "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto p-[10px] md:mb-[0px] lg:mb-[0px] px-[35px] lg:px-[15px] [&>div>div>div]:mb-[35px]",
  title:
    "text-[24px] lg:text-[48px] text-green font-Light my-[45px] leading-[1.2] tracking-normal mt-0 w-full text-left",
  linkClass:
    " font-Regular font-bold text-[14px] text-left md:text-[21px] text-purple tracking-[0.53px] md:tracking-[2.2px] hover:text-orange hover:underline",
}

export const GREEN_BG_LINKS = {
  wrapper:
    "greenBgLinkWithArrow px-[15px] test bg-greenBGLink bg-no-repeat bg-cover h-full py-[40px]",
  title:
    " text-[24px] mt-[-12px] text-green font-Light mx-10 tracking-normal leading-1.2 font-thin mt-0 w-full md:text-[48px] ",
  description: "description",
  rightContentWrapper: "md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto pt-[10px]",
  Para3:
    "linkWrapper font-Regular text-center text-[14px] md:text-[21px] tracking-[2.8px] md:tracking-[4.2px] uppercase text-white relative",
  leftContentWrapper: "leftContentWrapper test",
  linkClass:
    "linkClass md:text-[21px] underline-offset-4 hover:text-white hover:underline relative w-full px-[15px] box-border uppercase text-[14px] tracking-[2.8px] font-Regular cursor-pointer text-center",
}

export const NDP_SEE_ALL = {
  wrapper: "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto test w-full text-center",
  title:
    " text-[24px] mt-[-12px] text-green font-Light mx-10 tracking-normal leading-1.2 font-thin mt-0 w-full md:text-[48px]",
  rightContentWrapper: "SeeAllWrap",
  Para3: "lg:mx-15 mx-35",
  linkClass:
    "linkClass bg-purple inline-block text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.8px] lg:tracking-[4.2px] uppercase border-[2px] border-purple text-white hover:bg-lightpurple hover:border-lightpurple font-Bold px-[45px] py-[20px] rounded-[40px] mx-auto mb-[45px]",
}

export const TWO_COL_8_4_WIDTH = {
  wrapper: "wrapper lg:max-w-lg xl:max-w-xl mx-auto px-[20px] lg:flex",
  leftContentWrapper: "leftContentWrapper lg:w-4/6",
  title:
    "text-[24px] mt-[-12px] text-green font-Light tracking-normal leading-1.2 font-thin mt-0 w-full md:text-[24px] mb-[35px] px-[25px] lg:px-[40px] lg:text-[48px]",
  description:
    "description px-[30px] md:px-[45px] text-left text-[14px] md:text-[21px] font-Regular tracking-[0.53px] text-black mt-0 box-border mb-[60px] lg:text-[21px]  ",
  rightContentWrapper: "rightContentWrapper lg:w-2/6",
  Para3: "Para3 md:px-[100px] lg:px-[0px] ",
  linkClass:
    "linkClass   block w-full bg-purple text-white text-center font-Regular font-bold leading-[21px] tracking-[4.2px] px-[55px] py-20 rounded-[40px] uppercase border-2 border-purple hover:bg-lightpurple hover:border-lightpurple mt-[40px] mb-[30px]",
}

export const TWO_COL_8_4_WIDTH_PURPLE_WHITE_BUTTON = {
  wrapper: "wrapper lg:max-w-lg xl:max-w-xl mx-auto px-[20px] lg:flex ",
  leftContentWrapper: "leftContentWrapper lg:w-4/6",
  title:
    "text-[24px] mt-[-12px] text-green font-Light tracking-normal leading-1.2 font-thin mt-0 w-full md:text-[24px] mb-[35px] lg:text-[48px]",
  description:
    "description text-left text-[14px] md:text-[21px] font-Regular tracking-[0.53px] text-black mt-0 box-border mb-[60px] lg:text-[21px] [&>p>a:hover]:text-orange [&>p>a:hover]:underline ",
  rightContentWrapper: "rightContentWrapper lg:w-2/6 ",
  Para3:
    "Para3 md:px-[100px] lg:px-[0px] [&>div:nth-child(1):hover>a]:bg-lightpurple [&>div:nth-child(1):hover>a]:border-lightpurple [&>div:nth-child(2)>a]:bg-white [&>div:nth-child(2)>a]:text-purple [&>div:nth-child(2)>a]:font-bold [&>div:nth-child(2):hover>a]:bg-lightpurple [&>div:nth-child(2):hover>a]:text-white [&>div:nth-child(2):hover>a]:border-lightpurple",
  linkClass:
    "linkClass block w-full bg-purple text-white text-center font-Regular font-bold leading-[21px] tracking-[4.2px] px-[55px] py-20 rounded-[40px] uppercase border-2 border-purple  mt-[40px] mb-[30px] lg:mb-[50px] ",
}

export const GREEN_BG_COL_LINK = {
  ...defaultStyle,
  wrapper:
    "px-[15px] test bg-greenBGLink bg-no-repeat bg-cover py-[40px] mt-[-45px] lg:mt-[-60px]",
  rightContentWrapper:
    "jumplinkContainer rightContentWrapper max-w-[95%] w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  Para3: "linkWrapper Para3 lg:flex md:flex flex-row items-center",
  linkDiv:
    "test linkDiv lg:w-1/3 md:w-1/3 text-center border-r border-white last:border-none px-[25px] max-md:mb-20 max-md:border-none",
  linkClass:
    "linkClass relative inline-block text-white font-MDLZBiteType text-[21px] lg:text-[28px] md:text-[28px] leading-[32px]",
}
export const GREEN_BOTTOM_LINK = {
  ...GREEN_BG_COL_LINK,
  wrapper:
    "px-[15px] test bg-greenBGLink bg-no-repeat bg-cover py-[40px] md:mb-[45px]",
  rightContentWrapper:
    "jumplinkContainer rightContentWrapper max-w-[95%] w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  Para3: "linkWrapper Para3 lg:flex md:flex flex-row items-center",
  linkDiv:
    "test linkDiv lg:w-1/3 md:w-1/3 text-center border-r border-white last:border-none px-[25px] max-md:mb-20 max-md:border-none",
  linkClass:
    "linkClass relative inline-block text-white font-MDLZBiteType text-[21px] lg:text-[28px] md:text-[28px] leading-[32px]",
}

export const PURPLE_BUTTON = {
  linkDiv: "linkDiv mx-[20px]",
  linkClass:
    "linkClass bg-purple table text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.4px] lg:tracking-[4.2px] uppercase border-[2px] border-purple text-white hover:bg-lightpurple hover:border-lightpurple font-Bold px-[45px] py-[20px] rounded-[40px] mx-auto mb-[35px] lg:mb-[45px] md:text-[21px]",
}

export const PURPLE_BUTTON_LEFT = {
  ...PURPLE_BUTTON,
  wrapper: "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  linkClass:
    "linkClass bg-purple table text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.4px] lg:tracking-[4.2px] uppercase border-[2px] border-purple text-white hover:bg-lightpurple hover:border-lightpurple font-Bold px-[45px] py-[20px] rounded-[40px] mx-auto lg:ml-[15px] my-[35px] lg:my-[45px] md:text-[21px]",
}

export const REPORT_ARCHIVE_LINKS = {
  ...defaultStyle,
  wrapper: "px-[15px] test bg-greenBGLink bg-no-repeat bg-cover py-[40px]",
  title:
    " text-[24px] mt-[-12px] text-purple font-Light mx-10 tracking-normal leading-1.2 font-thin mt-0 w-full md:text-[48px]",
  rightContentWrapper:
    "jumplinkContainer rightContentWrapper max-w-[95%] w-full md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  Para3: "linkWrapper Para3 flex flex-row",
  linkDiv: "linkDiv w-1/3 text-center border-r border-white last:border-none",
  linkClass:
    "linkClass relative text-purple font-MDLZBiteType text-[28px] leading-[32px]",
}

export const PALEPURPLE_BG_LINKS = {
  bgWrapper:
    "bgWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[30px] md:px-[15px] h-full py-[40px] pt-[0]",
  wrapper: "bg-palePurple py-[10px] px-20",
  title:
    " text-[16px] text-center lg:text-left tracking-[2px] text-purple uppercase font-['Segoe_UI'] font-bold leading-[24px] mb-[10px]",
  description: "description",
  rightContentWrapper: "rightContentWrapper",
  Para3: "linkWrapper flex flex-wrap justify-center lg:justify-start",
  leftContentWrapper: "leftContentWrapper test",
  linkClass:
    "linkClass text-[14px] lg:text-[20px] relative px-15 py-[5px] font-Regular",
  activeLinkClass:
    "activeLinkClass linkDiv bg-purple text-white rounded-[30px] mb-[10px] mr-[15px]",
  linkDiv: "linkDiv bg-white rounded-[30px] text-black mb-[10px] mr-[15px] hover:bg-purple  hover:text-white",
}

export const LIGHTGREY_BG_SECTION = {
  bgWrapper:
    "bgWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[30px] md:px-[15px] lg:px-[15px] h-full py-[35px] md:py-[50px]",
  wrapper: "bg-lightGrey pt-20 pb-[60px] px-20",
  title:
    "text-[30px] lg:text-[50px] text-center lg:text-left tracking-normal lg:tracking-[1.2px] leading-[1.2] text-purple uppercase font-MDLZBiteType mb-20",
  description:
    "description text-[14px] lg:text-[20px] mb-[25px] tracking-[0.53px] pr-20 md:pr-0",
  rightContentWrapper: "rightContentWrapper",
  Para3: "linkWrapper flex flex-wrap justify-center lg:justify-start",
  leftContentWrapper: "leftContentWrapper test",
  linkClass:
    "linkClass font-MDLZBiteType font-bold text-[14px] lg:text-[20px] relative  uppercase leading-[1.1] ",
  activeLinkClass: "activeLinkClass",
  linkDiv:
    "linkDiv rounded-[30px] text-black  mr-[15px] px-[20px] py-15 text-white bg-lightpurple hover:border-b-2 hover:border-b-orange text-center lg:text-left leading-[1.1] w-full lg:w-auto",
}

export const GREEN_BG_LINKS_WITHIN_CONTENT = {
  ...GREEN_BG_LINKS,
  bgWrapper: "py-[50px]",
  wrapper:
    "greenBgLinkWithArrow md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px] test bg-greenBGLink bg-no-repeat bg-cover h-full py-[40px]",
}

export const PURPLE_BG_COL_LINK = {
  ...GREEN_BG_COL_LINK,
  wrapper: "px-[15px] test bg-purpleBGLink bg-no-repeat bg-cover py-[40px]",
  linkDiv: "linkDiv text-center border-r border-white last:border-none px-[20px] max-md:mb-20 max-md:border-none",
  linkClass: "linkClass relative inline-block text-white font-MDLZBiteType text-[18px] min-w-[120px] leading-[1.3]",
  Para3: "linkWrapper Para3 lg:flex md:flex flex-row items-start justify-center",
}

export const TYPO_PURPLE_BG_COL_LINK = {
  ...PURPLE_BG_COL_LINK,
  linkDiv: "typo-purple-link linkDiv text-center flex self-stretch relative first:after:content-none after:absolute after:content-[''] after:w-[1px] after:h-[52px] after:bg-[#ffffff] after:left-0 last:border-none px-[20px] max-md:mb-20 max-md:border-none",
  linkClass: "linkClass relative inline-block text-white font-MDLZBiteType text-[18px] min-w-[120px] leading-[1.3] self-center",
  Para3: "linkWrapper Para3 lg:flex md:flex flex-wrap flex-row items-start justify-center",
}

export const BLUE_BG_COL_LINK = {
  ...GREEN_BG_COL_LINK,
  bgWrapper: "bgWrapper",
  wrapper:
    "px-[15px] test bg-blueBGLink bg-no-repeat bg-cover py-[40px] relative top-[-30px] lg:top-[-60px]",
  rightContentWrapper:
    "jumplinkContainerWithBlueBg rightContentWrapper max-w-[95%] mx-auto",
  linkDiv:
    "linkDiv w-full md:w-1/3 text-center md:border-r md:border-black last:border-none px-[25px] mb-[20px] lg:mb-0",
  linkClass:
    "linkClass relative text-black font-MDLZBiteType text-[21px] lg:text-[28px] leading-[32px] block",
}

export const BLUE_BG_COL_LINK_SECTION = {
  ...BLUE_BG_COL_LINK,
  linkClass:
    "linkClass relative text-black font-MDLZBiteType text-[21px] md:text-[28px] leading-[32px] !tracking-normal block",
  wrapper:
    "px-[15px] test bg-blueBGLink bg-no-repeat bg-cover py-[45px] relative",
}
export const WHITE_BG_LINKS = {
  bgWrapper:
    "bgWrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[35px] md:px-[15px] lg:px-[0] h-full",
  wrapper:
    "text-justify w-full mx-auto box-border text-left lg:mx-0 px-0 lg:px-[15px] ",
  title:
    " box-border md:text-[21px] text-[14px] tracking-[0.53px] lg:text-[21px] text-left text-black italic font-Regular font-bold leading-[31.5px]",
  description: "description",
  rightContentWrapper:
    "rightContentWrapper  mb-0 tracking-[0.53px] mt-0 box-border text-[14px]",
  Para3: "Para3",
  leftContentWrapper:
    "leftContentWrapper test flex flex-wrap relative w-full box-border leading-[1.5]",
  linkClass:
    "linkClass inline-block text-purple text-[14px] md:text-[21px] font-bold relative font-Regular tracking-[0.53px] md:tracking-[2.2px] hover:text-orange hover:underline leading-[21px] md:leading-[31.5px] ",
  activeLinkClass:
    "activeLinkClass linkDiv bg-purple text-white rounded-[30px] mb-[10px] mr-[15px]",
  linkDiv:
    "linkDiv bg-white rounded-[30px] text-black inline-flex pipeline lg:pr-[3px]",
}

export const COL_GRID_PURPLE_TEXT = {
  ...defaultStyle,
  bgWrapper: "bgWrapper mb-[50px] md:mb-0 first:pl-[0]",
  wrapper: "wrapper px-[35px] lg:px-[15px]",
  Para3:
    "test box-border p-[0px] md:p-[10px] font-bold font-Calibri text-xl mt-0 mb-0 traking-widest text-purple",
  title:
    "text-[36px] md:text-[60px] text-purple tracking-[1.2px] leading-[1.2] font-MDLZBiteType font-light mt-0 w-full mb-[25px] lg:mb-[50px] text-center md:text-left break-words",
  linkDiv: "linkDiv mb-[25px] text-center md:text-left",
  linkClass:
    "linkClass text-[14px] md:text-[21px] text-purple hover:text-orange focus:text-orange hover:underline font-Regular font-bold mb-[25px] tracking-[2.8px] lg:tracking-[4.2px] leading-[30px]",
}

export const INLINE_BUTTON_PURPLE = {
  ...PURPLE_BUTTON,
  wrapper: "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  Para3:
    "Para3 lg:flex lg:justify-around lg:items-center pb-[30px] block box-border w-full px-[35px] lg:px-[15px] mx-auto box-border ",
}
export const INLINE_BUTTON_PURPLE_WITH_MAX_WIDTH = {
  ...INLINE_BUTTON_PURPLE,
  linkClass:
    "linkClass bg-purple table text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.4px] lg:tracking-[4.2px] uppercase border-[2px] border-purple text-white hover:bg-lightpurple hover:border-lightpurple font-Bold px-[45px] py-[20px] rounded-[40px] mx-auto mb-[35px] lg:mb-[45px] md:text-[21px] lg:max-w-[365px] lg:min-w-[365px]",
}
export const INLINE_BUTTON_PURPLE_WITH_BG = {
  ...INLINE_BUTTON_PURPLE,
  bgWrapper: "bg-grayWhite py-[50px] lg:py-[70px]",
  linkClass:
    "linkClass bg-purple table text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.4px] lg:tracking-[4.2px] uppercase border-[2px] border-purple text-white hover:bg-lightpurple hover:border-lightpurple font-Bold px-[45px] py-[20px] rounded-[40px] mx-auto mb-[35px] lg:mb-0 md:text-[21px]",
  Para3:
    "Para3 lg:flex lg:justify-around lg:items-center block box-border w-full px-[35px] lg:px-[15px] mx-auto box-border ",
}
export const BUTTON_LINKS = {
  ...defaultStyle,
  bgWrapper: "bg-[#FAFAFA] my-[30px] lg:my-50px]",
  wrapper: "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto py-[30px] px-[15px]",
  Para3:
    "inlineTwoColorBtn flex flex-col lg:flex-row items-center justify-around text-center font-bold font-Calibri mt-0 mb-0 traking-widest [&>div]:xl:w-full [&>*:nth-child(1)>a]:bg-[#e18719] [&>*:nth-child(2)>a]:bg-[#287819] [&>div]:py-[40px]",
  linkClass:
    "linkClass text-[14px] tracking-[2.8px] md:text-[21px] text-[#fff] inline-block rounded-[40px] border-2 border-solid border-[#fff] py-[20px] px-[36px] md:px-[45px] uppercase leading-[21px] md:tracking-[4.2px]",
}

export const COL_GRID_BORDER_GREEN_TITLE = {
  ...COL_GRID_PURPLE_TEXT,
  bgWrapper: "bgWrapper mb-[50px] md:mb-0 border-r border-darkgray",
  wrapper: "wrapper px-[50px]",
  title:
    "text-[36px] md:text-[48px] text-green tracking-[1.2px] leading-[1.2] font-Light mt-0 w-full mb-[25px] lg:mb-[50px] text-center md:text-left",
}

export const THREE_COL_GRID = {
  ...defaultStyle,
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
  container: "ContainerClimate md:block lg:flex flex",
  title:
    "md:text-[28px] text-[16px] mb-[10px] font-MDLZBiteType tracking-normal text-black text-center md:text-center lg:text-left",
  titleContent: "titleContent px-[15px]",
  headingWrapper: "climateWrapper py-[50px]",
  Content: "titleContent md:border-gray-400 px-[10px] pb-[25px] flex-1",
  description:
    "text-black font-Regular text-[14px] md:text-[21px] lg:text-[24px] mb-[10px] font-light tracking-[0.53px] leading-[31.5px] text-left",
}

export const THREE_COL_GRID_WITH_LIST = {
  ...THREE_COL_GRID,
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[10px]",
  container: "ContainerClimate block md:flex",
  titleContent: "titleContent",
  description:
    "text-black font-Regular text-[14px] md:text-[21px] mb-[10px] font-light tracking-[0.53px] leading-[31.5px] text-left pl-[25px] list-disc",
  title:
    "md:text-[21px] text-[24px] mb-[35px] font-Regular tracking-[0.53px] leading-[31.5px] text-black text-left md:text-left lg:text-left font-bold px-[20px] md:px-[20px] lg:px-[0px]",
}

export const THREE_COL_LINK_GRID = {
  ...THREE_COL_GRID,
  wrapper:
    "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto p-[10px] lg:mx-[-15px]  md:mb-[0px]  lg:mb-[0px] ",
  containerWrapper:
    "climateContainer md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto lg:py-[35px] mb-[30px] test",
  title:
    "text-[24px] lg:text-[48px] text-green font-Light my-[45px] leading-[1.2]  tracking-normal  font-light mt-0 w-full md:text-[24px] pl-[15px] ",
  linkwrap: "linkwrap lg:grid lg:grid-cols-3 md:grid md:grid-cols-3 px-[20px] ",
  linkContainer: "linkContainer",
  headingWrapper: "climateWrapper ",
  container: "ContainerClimate md:block lg:flex md:flex",
}

export const COL_GRID_PURPLE_TEXT_DIVIDER = {
  ...defaultStyle,
  bgWrapper:
    "bgWrapper md:mb-0 test md:border-r md:border-darkgray last:border-r-0 md:pl-[50px] md:first:pl-0 mb-[35px]",
  wrapper: "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto",
  Para3:
    "test box-border p-[0px] md:p-[10px] font-bold font-Calibri text-xl mt-0 mb-0 traking-widest text-purple",
  title:
    "text-[36px] md:text-[60px] text-purple tracking-[1.2px] leading-[1.2] font-MDLZBiteType mt-0 w-full mb-[25px] lg:mb-[50px] text-center md:text-left break-words",
  linkDiv:
    "linkDiv mb-[25px] lg:mb-[35px] last:mb-0 text-center md:text-left uppercase",
  linkClass:
    "linkClass text-[14px] md:text-[21px] text-purple hover:text-orange hover:underline font-Regular font-bold mb-[25px] tracking-[2.8px] md:tracking-[4.2px] leading-[30px]",
}

export const COL_GRID_GREEN_TITLE = {
  ...COL_GRID_PURPLE_TEXT,
  bgWrapper: "bgWrapper mb-[50px] md:mb-0",
  wrapper: "wrapper first:pl-[15px] md:px-[50px]",
  title:
    "text-[36px] md:text-[48px] text-green tracking-[1.2px] leading-[1.2] font-Light mt-0 w-full mb-[25px] lg:mb-[50px] text-center md:text-left",
  Para3:
    "test box-border p-[10px] md:py-[10px] md:px-0 font-bold font-Calibri text-xl mt-0 mb-0 traking-widest text-purple",
}
export const MULTI_lINK_CONTENT = {
  wrapper:
    "MultipleBtnsWrapper wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto px-[15px]",
  title:
    "text-[24px] lg:text-[48px] text-green font-Light my-[35px] leading-[1.2]  tracking-normal  font-light mt-0 w-full md:text-[24px]  ",
  Para3:
    "Para3 lg:flex flex-col lg:justify-around lg:items-center py-0 md:py-[30px] block box-border w-full mx-auto box-border ",
  linkDiv: "linkDiv",
  linkClass:
    "linkClass bg-purple table text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.8px] lg:tracking-[4.2px] uppercase border-[2px] border-purple text-white hover:bg-lightpurple hover:border-lightpurple font-Bold px-[45px] py-[20px] rounded-[40px] mx-auto my-[20px] lg:my-[20px] md:text-[21px] font-Regular font-bold",
  description:
    "text-black font-Regular text-[14px] md:text-[21px] mb-[10px] font-light tracking-[0.53px] leading-[21px] lg:leading-[31.5px] text-left  list-disc",
}
export const MULTI_lINK_CONTENT_PARTIAL_GRID = {
  ...MULTI_lINK_CONTENT,
  bgWrapper: "bgWrapper lg:pl-[40px] md:w-1/3",
  description:
    "[&>p]:mb-[35px] [&>p>a]:text-purple [&>p>a]:font-bold [&>p>a]:tracking-[0.53px] [&>p>a]:text-[14px] md:[&>p>a]:!tracking-[2.2px] md:[&>p>a]:!text-[21px] [&>p>a:hover]:!text-orange [&>p>a:hover]:underline",
  Para3: "hidden",
}
export const THREE_COLUMN_VIDEO = {
  linkClass: "LearnMoreVideoBtn",
}

export const ORANGE_BUTTON = {
  ...defaultStyle,
  bgWrapper: "bg-[#FAFAFA] my-[30px] lg:my-50px]",
  wrapper: "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto py-[30px] px-[15px]",
  Para3:
    "flex flex-col lg:flex-row justify-around text-center font-bold font-Calibri mt-0 mb-0 traking-widest [&>div]:xl:w-full [&>*:nth-child(1)>a]:bg-[#e18719]  [&>div]:py-[40px] hover:opacity-[70%] transition-[0.5s]",
  linkClass:
    "linkClass text-[14px] tracking-[2.8px] md:text-[21px] text-[#fff] inline-block rounded-[40px] border-2 border-solid border-[#fff] py-[20px] px-[45px] uppercase leading-[21px] md:tracking-[4.2px]",
}
export const SINGLE_ORANGE_BUTTON = {
  ...defaultStyle,
  bgWrapper: "bg-[#FAFAFA] my-[30px] lg:my-50px]",
  wrapper: "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto py-[30px] px-[15px]",
  Para3:
    "inlineTwoColorBtn SingleOrange flex flex-col lg:flex-row items-center justify-around text-center font-bold font-Calibri mt-0 mb-0 traking-widest [&>div]:xl:w-full [&>*:nth-child(1)>a]:bg-[#e18719] [&>*:nth-child(2)>a]:bg-[#287819] [&>div]:py-[40px]",
  linkClass:
    "linkClass text-[14px] tracking-[2.8px] md:text-[21px] text-[#fff] inline-block rounded-[40px] border-2 border-solid border-[#fff] py-[20px] px-[36px] md:px-[45px] uppercase leading-[21px] md:tracking-[4.2px]",
}
export const IMAGE_LINK_COLLECTION_CENTER = {
  wrapper:
    "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl mx-auto pb-[30px] md:pt-[20px] md:pb-[50px] px-[35px] lg:px-[15px]",
  description: "description flex justify-center",
}

export const PURPLE_BUTTON_VIEW = {
  linkDiv: "linkDiv mx-[20px]",
  linkClass:
    "linkClass bg-purple table text-center text-[14px] lg:text-[21px] transition-all leading-[21px] duration-[.5s] tracking-[2.4px] lg:tracking-[2.2px] uppercase border-[2px] border-purple text-white hover:bg-lightpurple hover:border-lightpurple font-Bold py-[20px] px-[45px] rounded-[40px] mx-auto mb-[35px] lg:mb-[45px] md:text-[21px] w-[280px] h-[65px] ",
}

export const GREEN_BG_LINKS_BOTTOM_SPACE = {
  ...GREEN_BG_LINKS,
  wrapper:
    "greenBgLinkWithArrow px-[15px] test bg-greenBGLink bg-no-repeat bg-cover h-full py-[40px] mb-[50px]",
}
export const MULTIPLE_FOOTER_LINKLIST_WITHOUT_BG = {
  wrapper:
    "wrapper md:max-w-md lg:max-w-lg xl:max-w-xl max-md:py-10",
  title:
    "text-[24px] lg:text-[48px] text-green font-Light my-[45px] leading-[1.2] tracking-normal font-light mt-0 w-full md:text-[24px] pl-[15px] ",
  linkClass:
    " font-Regular text-[14px] mb-0 text-left md:text-[21px] border-none  !text-[#4f2170] tracking-[4.2px] hover:!text-orange hover:underline uppercase inline-flex justify-center items-center !bg-transparent !p-0",
  leftContentWrapper: "text-left"
}